<template>
    <div>
        <p class="mb-0">
            <small>{{ $t(`profile.targetsTable.${evaluationType}`) }}</small>
        </p>
        <div>
            <div v-if="showEvaluation">
                <div v-if="evaluationValue != null">
                    <p class="text-right m-0">{{ formatPercentage(evaluationValue) }}%</p>
                    <progress-bar :value="evaluationValue" :color="evaluationColor" />
                    <b-link href="#" @click="openEvaluation" class="small" v-if="canView">{{
                        $t('profile.targetsTable.view')
                    }}</b-link>
                </div>
                <p class="m-0" v-else>-</p>
            </div>
            <div v-if="showEvaluateButton">
                <b-button
                    id="btn-target-evaluate"
                    href="#"
                    size="sm"
                    class="mt-1"
                    variant="outline-primary"
                    @click="changeAside(target)"
                    >{{ $t('profile.targetsTable.evaluate') }}</b-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import Aside from '@/shared/aside'
import { userPermissionsMixin } from '@/mixins'
import { formatPercentage } from '@/lib/utils'
import { TargetEvaluationAside } from '@/views/evaluation'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'

export default {
    name: 'Evaluation',
    props: [
        'evaluationType',
        'evaluationValue',
        'evaluationColor',
        'target',
        'showEvaluation',
        'isAllowedToEvaluate',
        'viewLink',
    ],
    mixins: [userPermissionsMixin],
    components: {
        ProgressBar,
        Aside,
    },
    data() {
        return {
            changeAsideEvaluationType: null,
            canView: true,
        }
    },
    mounted() {
        this.canView = this.viewLink != null ? this.viewLink : true
        if (this.evaluationType == 'selfEvaluate') {
            this.changeAsideEvaluationType = 'owner_evaluation'
        }

        if (this.evaluationType == 'managerEvaluate') {
            this.changeAsideEvaluationType = 'manager_evaluation'
        }

        if (this.evaluationType == 'committeeEvaluation') {
            this.changeAsideEvaluationType = 'committee_evaluation'
        }
    },
    computed: {
        permissions() {
            return this.$store.state.currentUser.user.permissions
        },
        showEvaluateButton() {
            return this.isAllowedToEvaluate && this.evaluationValue === null
        },
    },
    methods: {
        formatPercentage(number) {
            return formatPercentage(number, 2)
        },
        changeAside(target) {
            Aside.open(
                TargetEvaluationAside, //componente para renderizar
                { target, type: this.changeAsideEvaluationType }, //props para passar para o componente
                () => this.$emit('updated')
            )
        },
        openEvaluation() {
            this.$emit('view-evaluation', this.evaluationType)
        },
    },
}
</script>
